// extracted by mini-css-extract-plugin
export default {"BackButton":"ProcessWord_BackButton__Bkief"};